/**
 *
 * Create by liaokai on 2020-04-17 11:22:29
 */
import * as React from 'react';
import {Component} from "react";
import {RouteComponentProps} from "react-router";
import {SurfaceRouter, tSurfaceRouteItem} from "../../../../components/surface-router/surface-router";
import {CashRecord} from "./cash-record";


interface IProps extends RouteComponentProps{

}

interface IState{

}

const routerData : tSurfaceRouteItem = {
    breadTitle : "提现记录",
    routeName : "",
    component : CashRecord,
    children : []
};

export class CashRecordRouter extends Component<IProps,IState>{
    readonly state : IState = {

    };
    render() {
        let {} = this.props;
        let {} = this.state;
        return (
            <SurfaceRouter {...this.props} entryRoute={routerData}/>
        );
    }
}
